import React, { FunctionComponent } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { store } from "react-notifications-component"
import { Route, useHistory, useRouteMatch } from "react-router"
import { notificationOptions } from "../../../api/Definitions"
import { iArTarget } from "../../../definitions/ArTarget"
import { post } from "../../../store/data/actions"
import ARTargetHeader from "../Header"
import ARTargetOverview from "../inspector/Overview"
import ARTargetUploads from "../inspector/Uploads"

const CreateARTarget: FunctionComponent = () => {
  const history = useHistory()
  const match = useRouteMatch()

  const methods = useForm({ shouldUnregister: false })

  const onSubmit = (data: iArTarget) => {
    post<iArTarget>({ link: "/v1/create-ar-target", data }).then((target) => {
      history.push("/ar-targets/" + target.url)
      store.addNotification({
        title: "Success!",
        message: "Asset successfully created!",
        type: "success",
        ...notificationOptions,
      })
    })
  }

  return (
    <FormProvider {...methods}>
      <ARTargetHeader
        title="Create AR Target"
        submitDeleteText={"Delete"}
        submitText="Create"
        handleSubmit={() => {
          methods.handleSubmit((data) => {
            onSubmit(data as iArTarget)
          })()
        }}
      />
      <div className="inspector">
        <form className="inspector-form">
          <Route exact path={match.path}>
            <ARTargetOverview />
          </Route>
          <Route exact path={match.path + "/manage-files"}>
            <ARTargetUploads />
          </Route>
          <button className="d-none" type="submit">
            Submit
          </button>
        </form>
      </div>
    </FormProvider>
  )
}

export default CreateARTarget
